import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { Row, Col } from 'react-bootstrap';

import { formatDate, getCoverTypeIcon } from 'utils';
import { AccountSettingsItem } from './accountSettingsItem';
import { AccountMessage } from './accountMessage';
import { COVER_TYPE, FullPolicyData } from 'interfaces/customerDataTypes';

import './accountSettings.scss';

interface SettingsItem {
  key: string;
  value?: string | null;
  secondaryValue?: string;
  label: string;
  icon: JSX.Element;
}

interface AccountSettingsProps {
  selectedPolicy: FullPolicyData;
}

export const AccountSettings = ({ selectedPolicy }: AccountSettingsProps): JSX.Element => {
  const { riskAddress, riskPostcode, policyNumber, cardNumber, policyEndDate, atlasLifecycleStatus } = selectedPolicy;

  const SETTINGS_ITEMS: SettingsItem[] = [
    {
      key: 'riskAddress',
      value: riskAddress,
      secondaryValue: riskPostcode,
      label: 'Address insured',
      icon: <SvgIcon type={'map-marker' as HpSvgIconTypes} size="very-tiny" />
    },
    {
      key: 'coverType',
      value: COVER_TYPE.BUILDINGS,
      label: 'Insurance cover',
      icon: (
        <SvgIcon
          type={getCoverTypeIcon(COVER_TYPE.BUILDINGS) as HpSvgIconTypes}
          size="very-tiny"
          className="settings-icon"
        />
      )
    },
    {
      key: 'policyNumber',
      value: policyNumber,
      label: 'Policy reference',
      icon: <SvgIcon type={'document' as HpSvgIconTypes} size="very-tiny" />
    },
    {
      key: 'policyInceptionDate',
      value: formatDate(selectedPolicy.policyInceptionDate),
      label: 'Start date',
      icon: <SvgIcon type={'calendar-check' as HpSvgIconTypes} size="very-tiny" />
    },
    {
      key: 'policyEndDate',
      value: formatDate(policyEndDate),
      label: 'End date',
      icon: <SvgIcon type={'calendar-cross' as HpSvgIconTypes} size="very-tiny" />
    },
    {
      key: 'cardNumber',
      value: cardNumber,
      label: 'Account details',
      icon: <SvgIcon type={'credit-card' as HpSvgIconTypes} size="very-tiny" />
    }
  ];

  return (
    <div className="account-settings">
      <h2>GENERAL ACCOUNT SETTINGS</h2>
      <AccountMessage policyLifecycleStatus={atlasLifecycleStatus} />
      <Row>
        {SETTINGS_ITEMS.map(
          (item) =>
            selectedPolicy[item.key] &&
            item.value && (
              <Col key={item.key} xs={6} sm={4} className="details-column">
                <AccountSettingsItem
                  icon={item.icon}
                  label={item.label}
                  value={item.value}
                  secondaryValue={item.secondaryValue}
                />
              </Col>
            )
        )}
      </Row>
    </div>
  );
};
